<script setup lang="ts">
import PaginationCmn from '@/components/cmns/PaginationCmn.vue';
import TableTotalCmn from '@/components/cmns/TableTotalCmn.vue';
import { defCurPage, defPageSize } from '@/constants/routeQuery';

export interface Props {
  curPage?: number;
  pageSize?: number;
  total?: number;
  noPages?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  curPage: defCurPage,
  pageSize: defPageSize,
  total: 0,
  noPages: false,
});
</script>

<template>
  <footer :class="$style.tablePageFooter">
    <PaginationCmn
      v-if="!props.noPages"
      :length="Math.ceil(props.total / props.pageSize)"
      :page-size="props.pageSize"
      :selected="props.curPage"
      :class="$style.pagination"
    />
    <TableTotalCmn :class="$style.total" :total="props.total" />
    <div :class="$style.controls">
      <slot></slot>
    </div>
  </footer>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/variables';

.tablePageFooter {
  display: flex;
  align-items: center;
  margin: 22px;
  min-height: 40px;
}
  .pagination {
    margin-right: 26px;
  }
  .total {
    margin-left: auto;
  }
  .controls {
    margin-left: 17px;
  }
</style>
